import client from "../client";

const getAll = () => client.get<any>("/users");
const getTrainers = () => client.get<any>("/users/trainers");
const create = (data: any) => client.post<any>("/users", data);
const update = (id: number, data: any) =>
  client.patch<any>(`/users/${id}`, data);
const remove = (id: number) => client.delete<any>(`/users/${id}`);

const trainerApi = {
  getAll,
  getTrainers,
  create,
  update,
  remove,
};
export default trainerApi;
